import cloudMark from "@/assets/sanchezcloud-cloud-mark.svg";
import { m } from "@/i18n/en";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-3">
      <img alt="" className="size-8" src={cloudMark} />
      {!compact && (
        <div className="flex items-baseline gap-2">
          <span className="font-semibold">{m.brand}</span>
          <span className="text-sm text-secondary">{m.account}</span>
        </div>
      )}
    </div>
  );
}
